'use client';

import { Loader } from "rsuite";

export default function LoadingScreen() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-background">
      <Loader size="lg" content="Loading..." vertical/>
    </div>
  );
} 